<script setup lang="ts">
import type { HelpProvider } from '~/models/helpproviders';
import {  useUserFetch } from '~/composables/useUserApi';
const { data: helpProviders, refresh, pending } = await useUserFetch<HelpProvider[]>('/api/helpproviders');

</script>
<template>
  <div class="p-4 mainColor container mx-auto max-w-screen-lg">
    <SectionHeader header="Kontakt"  >
      Legekontor, legevakt eller medisinsk nødtelefon? Hva skal du velge når du
      trenger øyeblikkelig hjelp? Her får du oversikt over nødnummer.
    </SectionHeader>
    <div v-if="!pending" class="grid grid-cols-1 gap-6">
      <a v-for="helpProvider in helpProviders" :key="helpProvider.id" :href="'tel:' + helpProvider.contact">
        <div class="rounded-lg shadow-md border-1 border-[#dfdfdf] grid grid-cols-4">

          <div class="col-span-1 mainColorBackground flex justify-center items-center">
            <h2 class="text-xl md:text-2xl font-bold mb-2">{{ helpProvider.contact }}</h2>
          </div>
          <div class="col-span-3 px-6 py-8">
            <h2 class="text-xl md:text-2xl  font-bold mb-2">{{ helpProvider.title }}</h2>
            <p class="mb-2">{{ helpProvider.info }}</p>
          </div>

        </div>
      </a>
    </div>
  </div>
</template>
